import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { IMenuFilter } from '@nimbus-library/features/menu';
import { NimbusPermission } from '@nimbus-global/features/permissions/models/enums/nimbus-permission.enum';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { IPermissionManagerService } from '@nimbus-library/features/user-settings/services/contracts/i-permission-manager.service';
import { hasSelectedTeamPermission$ } from '@nimbus-global/features/permissions/models/has-selected-team-permission';

/**
 * Provide either `permission` (single) OR `permissions` (multi-permission, single-role check).
 */
export interface IPermissionFilterParameters {
  permission?: NimbusPermission;
  permissions?: NimbusPermission[];
  ignoreTeamSelection?: boolean;
}

export class PermissionFilter implements IMenuFilter<IPermissionFilterParameters> {
  public static for(parameter: IPermissionFilterParameters) {
    return { type: PermissionFilter, option: parameter };
  }

  public constructor(
    private readonly store: Store,
    private readonly authenticationService: IAuthenticationService,
    private readonly permissionManagerService: IPermissionManagerService,
  ) {}

  public validate$(parameter: IPermissionFilterParameters): Observable<boolean> {
    return hasSelectedTeamPermission$(this.store, this.permissionManagerService, parameter);
  }
}
